import script from "./appForms.vue?vue&type=script&setup=true&lang=js"
export * from "./appForms.vue?vue&type=script&setup=true&lang=js"

import "./appForms.vue?vue&type=style&index=0&id=76d3b70e&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/campus-heating-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76d3b70e"]])

export default __exports__